'use strict';

const analyticsHelper = require('../../util/analyticsHelper');

/**
 * Initializes the event handler for product tile selection.
 * 
 * Attaches a click event listener to elements with the class `.product-tile`.
 * When a product tile is clicked, it retrieves the product ID from the tile's body
 * and fires a Google Analytics 'select_item' event with the product information.
 *
 * Dependencies:
 * - jQuery
 * - analyticsHelper with a `trackEvent` method
 */
const initSelectItemEvent = () => {
    $('.product-tile').off('click').on('click', function (e) {
        if (e.originalEvent) {
            const tileBody = $(this).find('.tile-body');
            if (tileBody.length) {
                const productId = tileBody.data('product-id') || '';
                analyticsHelper.trackEvent('select_item', {
                    items: [{
                        item_id: productId
                    }]
                });
            }
        }
    });
}

module.exports = {
    initSelectItemEvent: initSelectItemEvent
}